import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/home/HomePage';
import TerminosYCondiciones from './components/TerminosYCondiciones';
import PrivacyPolicy from './components/PrivacyPolicy';
import DemoTicketTimes from './components/demotickettimes';
import DemoTicketQuality from './components/demoticketquality';
import DemoEasyApp from './components/demoeasyapp';
import DemoAdminSuite from './components/demoAdminSuite';
import DemoTicketTimeAnalyser from './components/demoTicketTimeAnalyser';
// import ZendeskConfigurator from './components/ZendeskConfigurator';
import ZendeskPromptsPage from './components/ZendeskPromptsPage';
import WorkbookPage from './components/WorkbookPage';
import ZendeskActionFlowsPage from './components/ZendeskActionFlowsPage';
import ZendeskOcrPage from './components/ZendeskOcrPage';
import SlaSimulator from './components/SlaSimulator';
import StartedGuide from './components/StartedGuide';

import './App.css';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen overflow-x-hidden w-full max-w-[100vw]">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms-and-conditions" element={<TerminosYCondiciones />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/demo-ticket-times" element={<DemoTicketTimes />} />
          <Route path="/demo-ticket-quality" element={<DemoTicketQuality />} />
          <Route path="/demo-easy-app" element={<DemoEasyApp />} />
          <Route path="/demo-admin-suite" element={<DemoAdminSuite />} />
          <Route path="/demo-ticket-time-analyser" element={<DemoTicketTimeAnalyser />} />
          {/* <Route path="/zendesk-configurator" element={<ZendeskConfigurator />} /> */}
          <Route path="/app-builder" element={<ZendeskPromptsPage />} />
          <Route path="/zendesk-workbook" element={<WorkbookPage />} />
          <Route path="/zendesk-action-flows" element={<ZendeskActionFlowsPage />} />
          <Route path="/zendesk-ocr" element={<ZendeskOcrPage />} />
          <Route path="/sla-simulator" element={<SlaSimulator />} />
          <Route path="/started-guide" element={<StartedGuide />} />
        </Routes>
        

      </div>
    </Router>
  );
}

export default App;